import { Icon } from '@tcweb/connect-ui';
import { Component, Show } from 'solid-js';
import { ToggleMenuItem } from './types';

interface ControlMenuToggleRowProps {
  item: ToggleMenuItem;
}

export const ControlMenuToggleRow: Component<ControlMenuToggleRowProps> = (
  props
) => (
  <>
    <Show when={props.item.icon}>
      <Show
        when={typeof props.item.icon === 'string'}
        fallback={props.item.icon}
      >
        <Icon
          icon={props.item.icon as string}
          class="flex min-w-5 min-h-5 text-base-content"
        />
      </Show>
    </Show>
    <span
      class="whitespace-nowrap flex-1 text-base-content"
      data-testid={'control-menu-dropdown-option-' + props.item.id}
    >
      {props.item.label}
    </span>
    <modus-wc-switch
      size="sm"
      value={props.item.value() ?? false}
      disabled={props.item.disabled}
    />
  </>
);
